
import { Component } from '@angular/core';
import { AuthService } from '@core/services/auth.service';
import { TranslocoModule } from '@jsverse/transloco';
import { ButtonModule } from '@shared/components/atoms/button/button.module';

@Component({
  selector: 'xt-portal-error-page',
  templateUrl: './error-page.component.html',
  styleUrls: ['./error-page.component.scss'],
  standalone: true,
  imports: [TranslocoModule, ButtonModule],
})
export class ErrorPageComponent {
  constructor(private authService: AuthService) {}

  onLogout() {
    this.authService.logoutOAuth();
  }
}
